/* eslint-disable object-curly-newline */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Container, Button } from "react-bootstrap";
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";
import { AvForm } from "availity-reactstrap-validation";

import { fetchReferrals } from "store/client/actions";
import { fetchAgreements, showSuccessNotification } from "store/actions";

import RecursiveTableRows from "./RecursiveTableRows";
import Select from "react-select";
import { fetchMamProfiles } from "store/mam-pam/actions";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { cpUrl } from "content";
import { profiles as allocationTypes } from "common/mam-pamm";
import CustomSelect from "components/Common/CustomSelect";
import * as XLSX from "xlsx";

const Referral = ({ t }) => {
  const dispatch = useDispatch();

  const { _id, referrals, fx } = useSelector(
    (state) => state.clientReducer?.clientDetails
  );
  const { agreements } = useSelector((state) => state.ibAgreements);
  const { profiles, loading } = useSelector((state) => ({
    profiles: state.mamPamReducer.profile?.profiles,
    loading: state.mamPamReducer.profile?.loading,
  }));

  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedReferral, setSelectedReferral] = useState(null);
  const [transactionDateFrom, setTransactionDateFrom] = useState("");
  const [transactionDateTo, setTransactionDateTo] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [filterLogin, setFilterLogin] = useState("");
  const allocationType = allocationTypes.find((item) => item.value === selectedProfile?.profileType)?.label ?? "-";

  const parentFirstName = referrals?.[0]?.firstName;
  const parentLastName = referrals?.[0]?.lastName;

  const grandTotalDeposits = referrals?.[0]?.grandTotalDeposits ?? 0;
  const grandTotalWithdrawals = referrals?.[0]?.grandTotalWithdrawals ?? 0;

  const filteredReferrals = selectedAgreement ?
    referrals?.[0]?.childs?.filter(referral => ((referral.fx.agrementId === selectedAgreement) || referral.fx.agrementId === undefined)) :
    referrals?.[0]?.childs;

  const childData = [];

  (filteredReferrals || []).forEach(child => {
    const data = getChildData(child, parentFirstName, parentLastName, 0);
    childData.push(data);
  });

  function getChildData(child, parentFirstName, parentLastName, level) {
    const data = {
      "Name": `${child?.firstName || ""} ${child?.lastName || ""}`,
      "Email": child?.email || "",
      "Parent Name": `${parentFirstName || ""} ${parentLastName || ""}`,
      "Client Type": child?.fx?.isIb ? "Sub IB" : "Client",
      "Live Accounts": child?.fx?.liveAcc?.length > 0 ? child?.fx?.liveAcc.join(", ") : "No Accounts",
      "Demo Accounts": child?.fx?.demoAcc?.length > 0 ? child?.fx?.demoAcc.join(", ") : "No Accounts",
      "Total Deposits": parseFloat(child?.totalDeposits || 0).toFixed(2),
      "Total Withdrawals": parseFloat(child?.totalWithdrawals || 0).toFixed(2),
      "Indentation Level": level
    };

    if (child.childs && child.childs.length > 0) {
      data["Childs"] = child.childs.map(subchild => getChildData(subchild, child.firstName, child.lastName, level + 1)); // Increase indentation level for nested child
    }

    return data;
  }

  const downloadRefferalsExcel = () => {
    const nestedChildData = [];

    nestedChildData.push([
      "Name",
      "Email",
      "Parent Name",
      "Client Type",
      "Live Accounts",
      "Demo Accounts",
      "Total Deposits",
      "Total Withdrawals"
    ]);

    function populateNestedChildData(data) {
      const index = nestedChildData.length - 1;
      const insertIndex = index < 0 ? 0 : index + 1;

      nestedChildData.splice(insertIndex, 0, [
        ...Array(data["Indentation Level"]).fill(""),
        data.Name,
        data.Email,
        data["Parent Name"],
        data["Client Type"],
        data["Live Accounts"],
        data["Demo Accounts"],
        data["Total Deposits"],
        data["Total Withdrawals"]
      ]);

      if (data["Childs"]) {
        data["Childs"].forEach(child => populateNestedChildData(child));

        nestedChildData.splice(insertIndex + 1, 0, [
          ...Array(data["Indentation Level"]).fill(""),
          "Child",
          "Name",
          "Email",
          "Parent Name",
          "Client Type",
          "Live Accounts",
          "Demo Accounts",
          "Total Deposits",
          "Total Withdrawals"
        ]);
      }
    }

    childData.forEach(child => populateNestedChildData(child));

    // Totals row at the bottom
    nestedChildData.push(["", "", "", "", "", "", "TOTAL DEPOSITS", "TOTAL WITHDRAWALS"]);
    nestedChildData.push(["", "", "", "", "", "", grandTotalDeposits.toFixed(2), grandTotalWithdrawals.toFixed(2)]);

    const ws = XLSX.utils.aoa_to_sheet([[]]);
    ws["!cols"] = [{ width: 10 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }];
    XLSX.utils.sheet_add_aoa(ws, nestedChildData, { origin: "A2" });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "referrals.xlsx");
  };

  const profileData = [{
    "Profile Type": allocationType,
    "Master Login": selectedProfile?.masterTradingAccountId?.login,
    "Fee Login": selectedProfile?.feeTradingAccountId?.login,
    "Members": selectedProfile?.slaves?.length,
    "Dedicated Link": `${cpUrl}/register/forex/investor?spRef=${selectedProfile?.recordId}`,
  }];

  const downloadProfileExcel = () => {
    const ws = XLSX.utils.json_to_sheet(profileData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "profile.xlsx");
  };

  const handleSearchReferrals = () => {
    if (!_id) return;
    const payload = {
      type: "live",
      clientId: _id,
    };
    if (transactionDateFrom) payload.transactionDateFrom = transactionDateFrom;
    if (transactionDateTo) payload.transactionDateTo = transactionDateTo;
    if (filterEmail) payload.email = filterEmail;
    if (filterLogin) payload.login = filterLogin;
    dispatch(fetchReferrals(payload));
  };

  const handleClearFilters = () => {
    setSelectedAgreement(null);
    setSelectedReferral(null);
    setSelectedProfile(null);
    setTransactionDateFrom("");
    setTransactionDateTo("");
    setFilterEmail("");
    setFilterLogin("");
    if (_id) {
      dispatch(fetchReferrals({
        type: "live",
        clientId: _id,
      }));
    }
  };

  useEffect(() => {
    if (_id) {
      dispatch(
        fetchReferrals({
          type: "live",
          clientId: _id,
        })
      );
      dispatch(fetchAgreements({ customerId: _id }));
      dispatch(fetchMamProfiles({
        customerId: _id,
        page: 1,
        limit: 100,
      }));
    }
  }, [_id]);

  const renderBody = (type) => {
    if (type === "IB") {
      return (
        <Table className="table table-hover text-center">
          <Thead>
            <Tr>
              <Th className="py-2 text-start">{t("Name")}</Th>
              <Th className="py-2 text-start">{t("Email Address")}</Th>
              <Th className="py-2 text-start">{t("Parent Name")}</Th>
              <Th className="py-2">{t("Client Type")}</Th>
              <Th className="py-2">{t("Accounts")}</Th>
              <Th className="py-2">{t("Total Deposits")}</Th>
              <Th className="py-2">{t("Total Withdrawals")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            <RecursiveTableRows
              data={referrals[0]}
              filter={selectedAgreement}
              level={0}
            />
          </Tbody>
          <tfoot>
            <tr style={{
              borderTop: "2px solid #ccc",
              fontWeight: "bold",
              background: "#f8f9fa",
            }}>
              <td className="py-2 text-start" colSpan={5}>{t("Grand Total")}</td>
              <td className="py-2 text-center">{grandTotalDeposits.toFixed(2)}</td>
              <td className="py-2 text-center">{grandTotalWithdrawals.toFixed(2)}</td>
            </tr>
          </tfoot>
        </Table>
      );
    } else if (type === "SP" && selectedProfile?.recordId) {
      return (
        <>
          <Table className="table table-hover text-center">
            <Thead>
              <Tr>
                <Th className="py-2 text-start">{t("Profile Type")}</Th>
                <Th className="py-2 text-start">{t("Master Login")}</Th>
                <Th className="py-2">{t("Fee Login")}</Th>
                <Th className="py-2">{t("Members")}</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Th className="py-2 text-start">{allocationType}</Th>
                <Th className="py-2 text-start">{selectedProfile?.masterTradingAccountId?.login}</Th>
                <Th className="py-2">{selectedProfile?.feeTradingAccountId?.login}</Th>
                <Th className="py-2">{selectedProfile?.slaves?.length}</Th>
              </Tr>
            </Tbody>
          </Table>
          <Card>
            <CardHeader className="py-3">
              <CardTitle className="mb-0">{t("Dedicated Link")}</CardTitle>
            </CardHeader>
            <CardBody>
              <Link to="#"
                className="mdi mdi-clipboard-check-multiple-outline font-size-20 me-2"
                onClick={() => {
                  navigator.clipboard.writeText(`${cpUrl}/register/forex/investor?spRef=${selectedProfile?.recordId}`);
                  dispatch(showSuccessNotification("Link copied to clipboard"));
                }}
              ></Link>
              {`${cpUrl}/register/forex/investor?spRef=${selectedProfile?.recordId}`}
            </CardBody>
          </Card>
        </>
      );
    }
  };

  return (
    <Container fluid className="gx-4" style={{
      minHeight: "60vh",
    }}>
      <AvForm className="d-flex flex-wrap align-items-end">
        <div className="row m-2">
          <label>{t("Referrals For")}</label>
          <CustomSelect
            className="w-full"
            name="referral"
            onChange={(e) => {
              setSelectedReferral(e.value);
            }}
            value={selectedReferral === null ? "" : undefined}
            options={
              (() => {
                const options = [];
                if (fx?.isIb) {
                  options.push({
                    label: "IB",
                    value: "IB",
                  });
                }
                if (fx?.isSp) {
                  options.push({
                    label: "Signal Provider",
                    value: "SP",
                  });
                }
                return options;
              })()
            }
          />
        </div>
        {
          selectedReferral === "IB" && <>
            <div className="row m-2">
              <label>{t("Select Agreement")}</label>
              <Select
                className="w-full"
                name="agreement"
                onChange={(e) => {
                  setSelectedAgreement(e.value);
                }}
                value={selectedAgreement === null ? "" : undefined}
                options={agreements?.map((agreement) => {
                  return {
                    label: agreement.title,
                    value: agreement._id,
                  };
                })}
              />
            </div>
            <div className="row m-2">
              <label>{t("Transaction Date From")}</label>
              <input
                type="date"
                className="form-control"
                value={transactionDateFrom}
                onChange={(e) => setTransactionDateFrom(e.target.value)}
              />
            </div>
            <div className="row m-2">
              <label>{t("Transaction Date To")}</label>
              <input
                type="date"
                className="form-control"
                value={transactionDateTo}
                onChange={(e) => setTransactionDateTo(e.target.value)}
              />
            </div>
            <div className="row m-2">
              <label>{t("Email")}</label>
              <input
                type="text"
                className="form-control"
                placeholder={t("Search by email")}
                value={filterEmail}
                onChange={(e) => setFilterEmail(e.target.value)}
              />
            </div>
            <div className="row m-2">
              <label>{t("Login")}</label>
              <input
                type="number"
                className="form-control"
                placeholder={t("MT4/MT5 login")}
                value={filterLogin}
                onChange={(e) => setFilterLogin(e.target.value)}
              />
            </div>
          </>
        }
        {
          selectedReferral === "SP" && <>
            <div className="row m-2">
              <label>{t("Select Profile")}</label>
              <CustomSelect
                className="w-full"
                name="profile"
                onChange={(e) => {
                  setSelectedProfile(e.value);
                }}
                value={selectedProfile && {
                  label: `${selectedProfile.profileType} | ${selectedProfile.masterTradingAccountId?.login} | ${selectedProfile.slaves?.length} Members`,
                  value: selectedProfile,
                }}
                options={profiles?.map((profile) => {
                  return {
                    label: `${profile.profileType} | ${profile.masterTradingAccountId?.login} | ${profile.slaves?.length} Members`,
                    value: profile,
                  };
                })}
              />
            </div>
          </>
        }
        <div className="row col-md-auto align-content-end m-2">
          <Button onClick={handleClearFilters}>
            {t("Clear")}
          </Button>
        </div>
        {selectedReferral === "IB" &&
          <div className="row col-md-auto align-content-end" style={{ margin: "0.5rem 0 0.5rem auto" }}>
            <Button onClick={handleSearchReferrals}>{t("Search")}</Button>
          </div>
        }
        {selectedReferral === "IB" &&
          <div className="row col-md-auto align-content-end" style={{ margin: "0.5rem 0 0.5rem auto" }}>
            <Button onClick={downloadRefferalsExcel}>{t("Download Referrals")}</Button>
          </div>
        }
        {selectedReferral === "SP" &&
          <div className="row col-md-auto align-content-end" style={{ margin: "0.5rem 0 0.5rem auto" }}>
            <Button disabled={!selectedProfile} onClick={downloadProfileExcel}>Download Profile</Button>
          </div>
        }
      </AvForm>
      {selectedReferral && (referrals?.length > 0 || selectedProfile !== null) && <Card className="p-4 m-2">
        {renderBody(selectedReferral)}
      </Card>}
    </Container>
  );
};

export default withTranslation()(Referral);
